/**
 * @generated SignedSource<<e90da0ce976f824f111a36c579b78d4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type categoriesQuery$variables = {
  categories?: ReadonlyArray<string> | null | undefined;
  organizations?: ReadonlyArray<string> | null | undefined;
  q?: string | null | undefined;
  tags?: ReadonlyArray<string> | null | undefined;
  topics?: ReadonlyArray<string> | null | undefined;
};
export type categoriesQuery$data = {
  readonly categories: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly displayName: string;
        readonly name: string;
      };
    }>;
  };
};
export type categoriesQuery = {
  response: categoriesQuery$data;
  variables: categoriesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categories"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizations"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "q"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tags"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "topics"
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "categories",
            "variableName": "categories"
          },
          {
            "kind": "Variable",
            "name": "organizations",
            "variableName": "organizations"
          },
          {
            "kind": "Variable",
            "name": "q",
            "variableName": "q"
          },
          {
            "kind": "Variable",
            "name": "tags",
            "variableName": "tags"
          },
          {
            "kind": "Variable",
            "name": "topics",
            "variableName": "topics"
          }
        ],
        "kind": "ObjectValue",
        "name": "filter"
      }
    ],
    "concreteType": "CategoryConnection",
    "kind": "LinkedField",
    "name": "categories",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CategoryEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Category",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "categoriesQuery",
    "selections": (v5/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "categoriesQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "a100a81b8ba2227a6d87646323869324",
    "id": null,
    "metadata": {},
    "name": "categoriesQuery",
    "operationKind": "query",
    "text": "query categoriesQuery(\n  $q: String\n  $tags: [String!]\n  $categories: [String!]\n  $organizations: [String!]\n  $topics: [String!]\n) {\n  categories(filter: {q: $q, topics: $topics, tags: $tags, organizations: $organizations, categories: $categories}) {\n    edges {\n      node {\n        name\n        displayName\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8ab2afe01cef19407b8344e838d321ca";

export default node;
